<template>
  <div id="page-home">
    <section class="section-notice" v-if="noticeList.length && this.enable_roll">
      <span class="notice-title">重点事件</span>
      <div class="notice-list">
        <ul class="scroll-content" :style="{ top }" @mouseenter="noticeStop()" @mouseleave="noticeUp()">
          <li v-for="item in noticeList" v-bind:key="item.id"><a :href="item.src" target="_blank">{{item.name}}</a></li>
        </ul>
      </div>
      <router-link to="/event" class="notice-all">全部事件</router-link>
    </section>
    <!-- 时间周期 ------------------------------------------------------------------------>
    <section class="section-timePeriod">
      <span class="timePeriod-title">时间周期</span>
      <ul class="btnGroup">
        <li
          class="btnItem"
          :class="{'btn-Item-selected': selectedTime.today}"
          @click="changeTime('1')"
        >今天</li>
        <li
          class="btnItem"
          :class="{'btn-Item-selected': selectedTime.last3d}"
          @click="changeTime('3')"
        >近3天</li>
        <li
          class="btnItem"
          :class="{'btn-Item-selected': selectedTime.last7d}"
          @click="changeTime('7')"
        >近7天</li>
        <li
          class="btnItem"
          :class="{'btn-Item-selected': selectedTime.last30d}"
          @click="changeTime('30')"
        >近30天</li>
        <li class="btnItem-datePicker" @click="changeTime('custom')">
          <DatePicker
            type="daterange"
            @on-ok="confirmDatePicker"
            v-model="dateRange"
            placement="bottom-end"
            placeholder="自定义"
            style="width: 200px"
            confirm
            class="datePicker"
            split-panels
          ></DatePicker>
        </li>
      </ul>
    </section>
    <!-- 统计数据 ------------------------------------------------------------------------>
    <section class="section-statistics">
      <ul class="list-statistics">
        <li class="listItem listItem-sum">
          <p class="listItem-title">总量</p>
          <p class="listItem-num">
            <countTo :startVal="0" :endVal="numData.sum" :duration="2500"></countTo>
          </p>
        </li>
        <li class="listItem listItem-positive">
          <p class="listItem-title">正面</p>
          <p class="listItem-num">
            <countTo :startVal="0" :endVal="numData.positive" :duration="2500"></countTo>
          </p>
        </li>
        <li class="listItem listItem-middle">
          <p class="listItem-title">中性</p>
          <p class="listItem-num">
            <countTo :startVal="0" :endVal="numData.middle" :duration="2500"></countTo>
          </p>
        </li>
        <li class="listItem listItem-negative">
          <p class="listItem-title">负面</p>
          <p class="listItem-num">
            <countTo :startVal="0" :endVal="numData.negative" :duration="2500"></countTo>
          </p>
        </li>
        <li class="listItem listItem-warn">
          <p class="listItem-title">预警</p>
          <p class="listItem-num">
            <countTo :startVal="0" :endVal="numData.warn" :duration="2500"></countTo>
          </p>
        </li>
      </ul>
    </section>
    <!-- 任务分布 ------------------------------------------------------------------------>
    <section class="section-taskDistribution">
      <h2 class="section-title">任务分布</h2>
      <div class="taskDistribution-content">
        <div class="ls">
          <div ref="charts_pie" class="charts_pie"></div>
          <p class="tip">点击图中的任务，可对下面的图表数据进行过滤并刷新</p>
        </div>
        <div class="rs">
          <div class="table-wrapper">
            <div class="table-task-head">
              <table cellspacing="0" cellpadding="0" border="0">
                <thead class="table-head">
                  <tr align="center">
                    <th>排序</th>
                    <th>任务</th>
                    <th>总量</th>
                    <th>占比</th>
                    <th>正面</th>
                    <th>中性</th>
                    <th>负面</th>
                    <th id="th-task-last">预警</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="table-task-content">
              <table cellspacing="0" cellpadding="0" border="0">
                <tbody class="table-body">
                  <tr v-for="(item,i) in taskDistributionData.tableData" :key="i">
                    <td>{{i+1}}</td>
                    <td>{{ item.name}}</td>
                    <td>{{item.total}}</td>
                    <td>{{item.ratio}}</td>
                    <td>{{item.positive}}</td>
                    <td>{{item.middle}}</td>
                    <td>{{item.negative}}</td>
                    <td id="td-task-last">{{item.warn}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="wrapper1">
      <!-- 舆情走势 ------------------------------------------------------------------------>
      <section class="section-trend">
        <h2 class="section-title">舆情走势{{currentTaskName}}</h2>
        <span class="icon-download" @click="downLoadTrendPic">下载</span>
        <loading-icon
          :isShowLoadingIcon="isBtnDownloadDisabled_trend"
          :loadingStyle="'top:30px; right: 24px'"
        ></loading-icon>
        <ul class="btnGroup">
          <li
            class="btnItem"
            :class="{'isSelected':btnTrendIsActive.all}"
            @click="handleSelectBtnTrend('all')"
          >全部</li>
          <li
            class="btnItem"
            :class="{'isSelected':btnTrendIsActive.source}"
            @click="handleSelectBtnTrend('source')"
          >来源分类</li>
          <li
            class="btnItem"
            :class="{'isSelected':btnTrendIsActive.emotions}"
            @click="handleSelectBtnTrend('emotions')"
          >情感分类</li>
        </ul>
        <div class="charts-wrapper">
          <div ref="charts_line_total" class="charts_line_total" v-show="btnTrendIsActive.all"></div>
          <div ref="charts_line_source" class="charts_line_source" v-show="btnTrendIsActive.source"></div>
          <div
            ref="charts_line_emotions"
            class="charts_line_emotions"
            v-show="btnTrendIsActive.emotions"
          ></div>
        </div>
<!--        <loading-->
<!--            :isLoading="isLoadingTrend"-->
<!--        ></loading>-->
      </section>
      <!-- 词云分析 ------------------------------------------------------------------------>
      <section class="section-wordCloud">
        <h2 class="section-title">词云分析{{currentTaskName}}</h2>
        <span class="icon-download" @click="downLoadWordCloudPic">下载</span>
        <loading-icon
          :isShowLoadingIcon="isBtnDownloadDisabled_wordCloud"
          :loadingStyle="'top:30px; right: 24px'"
        ></loading-icon>
        <div class="charts-wrapper">
          <div ref="charts_wordCloud" class="charts_wordCloud"></div>
        </div>
        <footer class="wordCloud-footer">
          <span class="wordCloud-legend legend-positive">正面</span>
          <span class="wordCloud-legend legend-middle">中性</span>
          <span class="wordCloud-legend legend-negative">负面</span>
        </footer>
<!--        <loading-->
<!--            :isLoading="isLoadingWordCloud"-->
<!--        ></loading>-->
      </section>
    </div>
    <div class="wrapper2">
      <!-- 情感分布 ------------------------------------------------------------------------>
      <section class="section-emotionsDistribution">
        <h2 class="section-title">情感分布{{currentTaskName}}</h2>
        <span class="icon-download" @click="downLoadEmotionsPic">下载</span>
        <loading-icon
          :isShowLoadingIcon="isBtnDownloadDisabled_emotions"
          :loadingStyle="'top:30px; right: 24px'"
        ></loading-icon>
        <div class="charts-wrapper">
          <div ref="charts_circle" class="charts_circle"></div>
        </div>
<!--        <loading-->
<!--            :isLoading="isLoadingEmotionsDistribution"-->
<!--        ></loading>-->
      </section>
      <!-- 媒体预警量排行 ------------------------------------------------------------------------>
      <section class="section-mediaAlert">
<!--         <h2 class="section-title">媒体预警量排行{{currentTaskName}}</h2>
        <table cellspacing="0" cellpadding="0" border="0" class="table-mediaAlert table">
          <thead class="table-head">
            <tr align="center">
              <th>媒体</th>
              <th>预警量</th>
              <th>总量</th>
              <th>预警比例</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr v-for="(item,i) in mediaAlertData" :key="i">
              <td>{{item.name}}</td>
              <td>{{item.alertAmount}}</td>
              <td>{{item.total}}</td>
              <td>{{item.alertRatio}}</td>
            </tr>
          </tbody>
        </table>-->
        <h2 class="section-title">重点事件预警</h2>
            <table cellspacing="0" cellpadding="0" border="0" class="table-highlightEvent table">
              <thead class="table-head">
                <tr align="center">
                  <th>日期</th>
                  <th>事件</th>
                  <th>人数预测</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr v-for="(item,i) in highlightEvent" :key="i">
                  <td>{{item.timeDur}}</td>
                  <td :title="item.eventName">{{item.eventName}}</td>
                  <td>{{item.peopleNum}}</td>
                </tr>
              </tbody>
            </table>
<!--        <loading-->
<!--            :isLoading="isLoadingMediaAlert"-->
<!--        ></loading>-->
      </section>
    </div>
    <div class="wrapper3">
      <!-- 群组监测 ------------------------------------------------------------------------>
      <section class="section-groupSpec">
        <h2 class="section-title">群组监测{{currentTaskName}}</h2>
        <table cellspacing="0" cellpadding="0" border="0" class="table">
          <thead class="table-head">
            <tr align="center">
              <th>群组</th>
              <th>预警量</th>
              <th>消息总量</th>
              <th>预警比例</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr v-for="(item,i) in groupSpecData" :key="i">
              <td :title="item.name">{{item.name}}</td>
              <td>{{item.alertAmount}}</td>
              <td>{{item.total}}</td>
              <td>{{item.alertRatio}}</td>
            </tr>
          </tbody>
        </table>
<!--        <loading-->
<!--            :isLoading="isLoadingGroupSpecAndActiveUser"-->
<!--        ></loading>-->
      </section>
      <!-- 群组活跃用户监测 ------------------------------------------------------------------------>
      <section class="section-activeUserSpec">
        <h2 class="section-title">群组活跃用户监测{{currentTaskName}}</h2>
        <table cellspacing="0" cellpadding="0" border="0" class="table">
          <thead class="table-head">
            <tr align="center">
              <th>用户</th>
              <th>参与群组</th>
              <th>总发言</th>
              <th>预警数</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr v-for="(item,i) in activeUserSpecData" :key="i">
              <td>{{item.sendMsgName}}</td>
              <td>{{item.diffGroupNum}}</td>
              <td>{{item.totalCount}}</td>
              <td>{{item.warningCount}}</td>
            </tr>
          </tbody>
        </table>
<!--        <loading-->
<!--            :isLoading="isLoadingGroupSpecAndActiveUser"-->
<!--        ></loading>-->
      </section>
    </div>
    <!-- loading动画 --------------------------------------------------------------------------->
    <loading
      :isLoading="isLoadingTotalAndTaskDistrubution"
    ></loading>
  </div>
</template>
<script>
import countTo from "vue-count-to";

export default {
  data() {
    return {
      enable_roll: false,
      noticeList:[],
      noticeIndex: 0,
      noticeIntnum: undefined,
      //正在加载<舆情总量和任务分布饼图数据>
      isLoadingTotalAndTaskDistrubution: false,
      //正在加载<舆情走势折线图数据>
      isLoadingTrend: false,
      //正在加载<词云分析数据>
      isLoadingWordCloud: false,
      //正在加载<情感分布空心饼图数据>
      isLoadingEmotionsDistribution: false,
      //正在加载<媒体预警量排行表格数据>
      isLoadingMediaAlert: false,
      isHighlightEventAlert: false,
      //正在加载<群组监测和活跃用户监测表格数据>
      isLoadingGroupSpecAndActiveUser: false,
      //<舆情走势>的下载按钮是否禁用
      isBtnDownloadDisabled_trend: true,
      //<词云分析>的下载按钮是否禁用
      isBtnDownloadDisabled_wordCloud: true,
      //<情感分布>的下载按钮是否禁用
      isBtnDownloadDisabled_emotions: true,
      //控制<时间周期>tab按钮样式
      selectedTime: {
        today: true,
        last3d: false,
        last7d: false,
        last30d: false,
        custom: false
      },
      //datePicker绑定的值
      dateRange: [],
      //数字统计绑定数据
      numData: {
        sum: 0,
        positive: 0,
        middle: 0,
        negative: 0,
        warn: 0
      },
      //<任务分布>模块数据
      taskDistributionData: {
        pieData: [],
        tableData: []
      },
      //<舆情走势>tab按钮切换
      btnTrendIsActive: {
        all: true,
        source: false,
        emotions: false
      },
      //<舆情走势>模块数据
      sentimentTrendData: {
        xData: [],
        charts_all: [],
        charts_source: {
          data_legend: [],
          data_y: []
        },
        charts_emotion: {
          data_legend: ["正面", "负面", "中性"],
          data_y: [
            {
              name: "正面",
              type: "line",
              data: [],
              smooth: true,
              itemStyle: {
                normal: {
                  color: "#44C58D",
                  lineStyle: {
                    color: "#44C58D"
                  }
                }
              }
            },
            {
              name: "负面",
              type: "line",
              data: [],
              smooth: true,
              itemStyle: {
                normal: {
                  color: "#FA5D5D",
                  lineStyle: {
                    color: "#FA5D5D"
                  }
                }
              }
            },
            {
              name: "中性",
              type: "line",
              data: [],
              smooth: true,
              itemStyle: {
                normal: {
                  color: "#FFA810",
                  lineStyle: {
                    color: "#FFA810"
                  }
                }
              }
            }
          ]
        }
      },
      //<词云分析>模块数据
      wordCloudData: [],
      //<情感分布>模块数据
      emotionsDistrubutionData: [],
      //<媒体预警量排行>模块数据
      mediaAlertData: [],
      highlightEvent: [],
      //<群组监测>模块数据
      groupSpecData: [],
      //<群组活跃用户监测>模块数据
      activeUserSpecData: [],
      //按时间筛选的tab按钮对应的时间数据(默认为'今天')
      startTime: new Date().setHours(0, 0, 0, 0),
      endTime: new Date().getTime(),
      //当前点击的任务id
      currentTaskId: "",
      //当前选中的任务名称
      currentTaskName: "",
      //记录每一个图表的dataUrl
      echartsDataUrl: {
        url_trend_all: "", //舆情走势--全部
        url_trend_source: "", //舆情走势--来源分类
        url_trend_emotions: "", //舆情走势--情感分类
        url_wordCloud: "", //词云分析
        url_emotions: "" //情感分布
      }
    };
  },
  components: {
    countTo
  },
  computed: {
    top() {
      return -this.noticeIndex * 40 + 'px';
    }
  },
  created() {
    //获取舆情总量和任务分布饼图数据
    this.getTotalAndTaskDistributionInfo();
    this.noticeScrollUp();
    this.getNoticeList();
    this.getAuthorities();
  },
  mounted() {
    //生成<词云分析>图表
    this.generateCharts_wordCloud();
    //生成<情感分布>图表
    this.generateCharts_circle();
  },
  methods: {
    getAuthorities() {
      let authorites = this.getLocalStorage("authorities").split(",");
      this.enable_roll = authorites.includes("event_roll");
    },
    //点击<时间周期>tab按钮
    changeTime(prop) {
      let selectedTimeProp = "custom";
      switch (prop) {
        case "1":
          selectedTimeProp = "today";
          break;
        case "3":
          selectedTimeProp = "last3d";
          break;
        case "7":
          selectedTimeProp = "last7d";
          break;
        case "30":
          selectedTimeProp = "last30d";
          break;
        default:
          break;
      }
      this.selectedTime.today = this.selectedTime.last3d = this.selectedTime.last7d = this.selectedTime.last30d = false;
      if (selectedTimeProp !== "custom") {
        this.dateRange = []; //清空datePicker的数据
        this.selectedTime[selectedTimeProp] = true;
        this.endTime = new Date().getTime();
        if (selectedTimeProp === "today") {
          //如果是<今天>，则是今天00:00-现在时刻
          this.startTime =
            new Date().setHours(0, 0, 0, 0) -
            1000 * 60 * 60 * 24 * (parseInt(prop) - 1);
        } else {
          //如果不是<今天>，则倒推到(n-1)天前的0点，例如今天是15日，近3天的起始时间是13日的0点
          this.startTime =
            new Date().setHours(0, 0, 0, 0) -
            1000 * 60 * 60 * 24 * (parseInt(prop) - 1);
        }
        this.currentTaskId = "";
        this.currentTaskName = "";
        this.getTotalAndTaskDistributionInfo();
      }
    },
    // 获取重点事件轮播数据
    getNoticeList() {
      this.$ajax({
        method: "get",
        url: "./highlightEvent/getRecentHighlightEventRoll"
      })
      .then(res => {
        if (res.data.success) {
          this.noticeList = res.data.data
        }
      })
      .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
      });
    },
    //获取舆情总量和任务分布饼图及表格数据
    getTotalAndTaskDistributionInfo() {
      if (this.isLoadingTotalAndTaskDistrubution) return;
      this.isLoadingTotalAndTaskDistrubution = true;
      this.$ajax({
        method: "get",
        url: "./summary/num",
        params: {
          startTime: this.startTime,
          endTime: this.endTime
        }
      })
        .then(res => {
          this.isLoadingTotalAndTaskDistrubution = false;
          //如果存在res.data
          if (res.data.success) {
            let resData = res.data.data;
            //更新舆情总量统计数据
            this.numData.sum = resData.total.value || 0;
            this.numData.positive = resData.total.positiveCount || 0;
            this.numData.middle = resData.total.neutralCount || 0;
            this.numData.negative = resData.total.negativeCount || 0;
            this.numData.warn = resData.total.isWarnCount || 0;
            //更新任务分布饼图数据
            resData.topGroupData = resData.topGroupData || [];
            //先清空
            this.taskDistributionData.pieData = [];
            resData.topGroupData.forEach(item => {
              this.taskDistributionData.pieData.push({
                jobId: item.jobId,
                name: item.name,
                value: item.value
              });
            });
            //绘制<任务分布>饼图
            this.generateCharts_pie();
            //更新任务分布表格数据
            //先清空
            this.taskDistributionData.tableData = [];
            resData.topGroupData.forEach(item => {
              this.taskDistributionData.tableData.push({
                id: item,
                name: item.name,
                total: item.value,
                ratio: item.percent + "%",
                positive: item.positiveCount,
                middle: item.neutralCount,
                negative: item.negativeCount,
                warn: item.isWarnCount
              });
            });
            //获取舆情走势数据
            this.getTrendInfo();
            //获取词云分析数据
            this.getWordCloudInfo();
            //获取情感分布走势数据
            this.getEmotionsDistributionInfo();
            //获取媒体预警量排行数据
            this.getMediaAlertInfo();
            this.getHighlightEventInfo();
            //获取群组监测和活跃用户数据
            this.getGroupSpecInfoAndActiveUser();
            this.$nextTick(() => {
              this.changeTaskTableStyle();
            });
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取舆情走势的数据
    getTrendInfo() {
      if (this.isLoadingTrend) return;
      this.isLoadingTrend = true;
      this.$ajax({
        method: "get",
        url: "./summary/trends",
        params: {
          startTime: this.startTime,
          endTime: this.endTime,
          jobId: this.currentTaskId,
          showType: 0
        }
      })
        .then(res => {
          this.isLoadingTrend = false;
          if (res.data.success) {
            let resData = res.data.data;
            this.sentimentTrendData.xData = [...resData.dateList];
            //更新<全部>折线图数据
            this.sentimentTrendData.charts_all = [...resData.totalTrends];
            //生成<全部>折线图
            this.generateCharts_line_all();

            //更新<来源分类>折线图数据
            //先清空
            this.sentimentTrendData.charts_source.data_legend = [];
            this.sentimentTrendData.charts_source.data_y = [];
            for (let prop in resData.sourceTrends) {
              this.sentimentTrendData.charts_source.data_legend.push(prop);
              this.sentimentTrendData.charts_source.data_y.push({
                name: prop,
                type: "line",
                data: [...resData.sourceTrends[prop]],
                smooth: true
              });
            }
            //生成<来源分类>折线图
            this.generateCharts_line_source();
            //更新<情感分类>折线图数据
            //先清空
            this.sentimentTrendData.charts_emotion.data_legend = [];
            this.sentimentTrendData.charts_emotion.data_y = [];
            for (let prop in resData.emotionTrends) {
              this.sentimentTrendData.charts_emotion.data_legend.push(prop);
              let item = {
                name: prop,
                type: "line",
                smooth: true,
                itemStyle: {
                  normal: {
                    color: (function(prop) {
                      let color = "#44C58D";
                      switch (prop) {
                        case "正面":
                          color = "#44C58D";
                          break;
                        case "负面":
                          color = "#FA5D5D";
                          break;
                        case "中性":
                          color = "#FFA810";
                          break;
                        default:
                          break;
                      }
                      return color;
                    })(prop),
                    lineStyle: {
                      color: (function(prop) {
                        let color = "#44C58D";
                        switch (prop) {
                          case "正面":
                            color = "#44C58D";
                            break;
                          case "负面":
                            color = "#FA5D5D";
                            break;
                          case "中性":
                            color = "#FFA810";
                            break;
                          default:
                            break;
                        }
                        return color;
                      })(prop)
                    }
                  }
                },
                data: [...resData.emotionTrends[prop]]
              };
              this.sentimentTrendData.charts_emotion.data_y.push(item);
            }
            //生成<情感分类>折线图
            this.generateCharts_line_emotions();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //点击<舆情走势>下载按钮
    downLoadTrendPic() {
      if (this.isBtnDownloadDisabled_trend) return;
      let url = "";
      let picTitle = "";
      if (this.btnTrendIsActive.all) {
        picTitle = "舆情走势(全部).png";
        url = this.echartsDataUrl.url_trend_all;
      } else if (this.btnTrendIsActive.source) {
        picTitle = "舆情走势(来源分类).png";
        url = this.echartsDataUrl.url_trend_source;
      } else if (this.btnTrendIsActive.emotions) {
        picTitle = "舆情走势(情感分类).png";
        url = this.echartsDataUrl.url_trend_emotions;
      }
      let a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", picTitle);
      a.click();
    },
    //点击<舆情走势>下载按钮
    downLoadWordCloudPic() {
      if (this.isBtnDownloadDisabled_wordCloud) return;
      let a = document.createElement("a");
      a.setAttribute("href", this.echartsDataUrl.url_wordCloud);
      a.setAttribute("download", "词云分析.png");
      a.click();
    },
    //点击<情感分布>下载按钮
    downLoadEmotionsPic() {
      if (this.isBtnDownloadDisabled_emotions) return;
      let a = document.createElement("a");
      a.setAttribute("href", this.echartsDataUrl.url_emotions);
      a.setAttribute("download", "情感分布.png");
      a.click();
    },
    //获取词云分析数据
    getWordCloudInfo() {
      if (this.isLoadingWordCloud) return;
      this.isLoadingWordCloud = true;
      this.$ajax({
        method: "get",
        url: "./summary/keyword/result",
        params: {
          startTime: this.startTime,
          endTime: this.endTime,
          jobId: this.currentTaskId,
          sourceName: "",
          showType: 0,
          count: 20
        }
      })
        .then(res => {
          this.isLoadingWordCloud = false;
          if (res.data.success) {
            //先清空
            this.wordCloudData = [];
            let resData = res.data.data;
            resData.forEach(item => {
              this.wordCloudData.push({
                name: item.keyword,
                value: item.num,
                prop: item.feeling,
                textStyle: this.generateColor(parseInt(item.feeling))
              });
            });
            //生成词云图
            this.generateCharts_wordCloud();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取情感分布的数据
    getEmotionsDistributionInfo() {
      if (this.isLoadingEmotionsDistribution) return;
      this.isLoadingEmotionsDistribution = true;
      this.$ajax({
        method: "get",
        url: "./summary/stat",
        params: {
          startTime: this.startTime,
          endTime: this.endTime,
          jobId: this.currentTaskId,
          showType: 0
        }
      })
        .then(res => {
          this.isLoadingEmotionsDistribution = false;
          //如果存在res.data
          if (res.data.success) {
            let resData = res.data.data;
            resData.emotions = resData.emotions || [];
            //先清空
            this.emotionsDistrubutionData = [];
            resData.emotions.forEach(item => {
              this.emotionsDistrubutionData.push({
                value: item.value,
                name: item.name,
                itemStyle: {
                  normal: {
                    color: (function(name) {
                      let color = "#44C58D";
                      switch (name) {
                        case "正面":
                          color = "#44C58D";
                          break;
                        case "负面":
                          color = "#FA5D5D";
                          break;
                        case "中性":
                          color = "#FFA810";
                          break;
                        default:
                          break;
                      }
                      return color;
                    })(item.name),
                    lineStyle: {
                      color: (function(name) {
                        let color = "#44C58D";
                        switch (name) {
                          case "正面":
                            color = "#44C58D";
                            break;
                          case "负面":
                            color = "#FA5D5D";
                            break;
                          case "中性":
                            color = "#FFA810";
                            break;
                          default:
                            break;
                        }
                        return color;
                      })(item.name)
                    }
                  }
                }
              });
            });
            //生成情感分布空心饼图
            this.generateCharts_circle();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取媒体预警量排行的数据
    getMediaAlertInfo() {
      if (this.isLoadingMediaAlert) return;
      this.isLoadingMediaAlert = true;
      this.$ajax({
        method: "get",
        url: "./summary/mediaWarning",
        params: {
          startTime: this.startTime,
          endTime: this.endTime,
          jobId: this.currentTaskId
        }
      })
        .then(res => {
          this.isLoadingMediaAlert = false;
          if (res.data.success) {
            let resData = res.data.data;
            resData.mediaWarns = resData.mediaWarns || [];
            //先清空
            this.mediaAlertData = [];
            for (let i = 0; i < resData.mediaWarns.length; i++) {
              let item = {
                id: i,
                name: resData.mediaWarns[i].name,
                alertAmount: resData.mediaWarns[i].warningCount,
                total: resData.mediaWarns[i].totalCount,
                alertRatio: resData.mediaWarns[i].percent + "%"
              };
              this.mediaAlertData.push(item);
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取媒体预警量排行的数据
    getHighlightEventInfo() {
      if (this.isHighlightEventAlert) return;
      this.isHighlightEventAlert = true;
      this.$ajax({
        method: "get",
        url: "./summary/highlightEvent",
        params: {
          startTime: this.startTime,
          endTime: this.endTime,
          jobId: this.currentTaskId
        }
      })
        .then(res => {
          this.isHighlightEventAlert = false;
          if (res.data.success && res.data.data) {
            let resData = res.data.data;
            this.highlightEvent = [];
            if (Array.isArray(resData)) {
              this.highlightEvent = resData;
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error(res.data.message || "服务器错误");
            }
          }
        })
        .catch(err => {
          this.isHighlightEventAlert = false;
          this.$Message.error("请求失败,请重试");
          console.log(err);
        });
    },
    //获取群组监测和群组活跃用户监测的数据
    getGroupSpecInfoAndActiveUser() {
      if (this.isLoadingGroupSpecAndActiveUser) return;
      this.isLoadingGroupSpecAndActiveUser = true;
      this.$ajax({
        method: "get",
        url: "./summary/groupWarning",
        params: {
          startTime: this.startTime,
          endTime: this.endTime,
          jobId: this.currentTaskId
        }
      })
        .then(res => {
          this.isLoadingGroupSpecAndActiveUser = false;
          if (res.data.success) {
            let resData = res.data.data;
            resData.groupWarns = resData.groupWarns || [];
            resData.activeUsers = resData.activeUsers || [];
            //先清空
            this.groupSpecData = [];
            this.activeUserSpecData = [];
            resData.groupWarns.forEach(item => {
              this.groupSpecData.push({
                name: item.groupName,
                alertAmount: item.warningCount,
                total: item.totalCount,
                alertRatio: item.percent + "%"
              });
            });
            resData.activeUsers.forEach(item => {
              this.activeUserSpecData.push({
                id: item.senderId,
                sendMsgName: item.sendMsgName,
                warningCount: item.warningCount,
                totalCount: item.totalCount,
                diffGroupNum: item.diffGroupNum
              });
            });
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");

          console.log(err);
        });
    },
    //点击<时间周期>datePicker的确认按钮
    confirmDatePicker() {
      let startMs = new Date(this.dateRange[0]).getTime();
      let endMs = new Date(this.dateRange[1]).getTime();
      // if (endMs - startMs > 1000 * 60 * 60 * 24 * 30 * 6) {
      //   //如果选择日期跨度大于90天
      //   this.dateRange = [];
      //   this.$Message.error("选择的日期跨度不能大于180天");
      //   return;
      // } else {
        this.startTime = startMs;
        this.endTime = endMs + 1000 * 60 * 60 * 24 - 1;
        this.getTotalAndTaskDistributionInfo();
      // }
    },
    //生成饼状图
    generateCharts_pie() {
      let myChart = this.echarts.init(this.$refs.charts_pie);
      let option = {
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "75%",
            center: ["50%", "50%"],
            label: {
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "20",
                  fontWeight: "bold"
                }
              }
            },
            data: this.taskDistributionData.pieData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };

      myChart.setOption(option, true);
      //绑定点击事件之前先解绑，防止重复绑定
      myChart.off('click');
      myChart.on("click", e => {
        if (e.data.name === "其他") return;
        //如果之前已经选中了该任务，则再次点击该任务时还原选中任务
        if(e.data.jobId===this.currentTaskId){
          this.initCharts_pie(myChart,option);
          return;
        }
        this.currentTaskId = e.data.jobId;
        this.currentTaskName = "-" + e.data.name;
        this.taskDistributionData.pieData = this.taskDistributionData.pieData.map(item => {
          item.selected = item.jobId === this.currentTaskId ? true : false;
          return item;
        });
        //添加饼状图相关模块选中状态
        myChart.setOption(option,true);
        //重新获取舆情走势、词云分析、情感分布、媒体预警排行量、群组监测和活跃用户数据并刷新图表及表格
        this.refreshChartsData();
      });

      myChart.getZr().on("click", params => {
        if (!params.target) {
          //点击了饼状图的空白处，如果当前没有选中的任务，则不触发任何事件，否则重新发起请求
          if (this.currentTaskId !== "") {
            this.initCharts_pie(myChart,option);
          }
        }
      });
    },
    //如果点击了空白处，或者点击了上一次选中的任务模块，则回归到选中所有任务
    initCharts_pie(myChart,option) {
      //还原样式
      this.currentTaskId = "";
      this.currentTaskName = "";
      this.taskDistributionData.pieData = this.taskDistributionData.pieData.map(item => {
        item.selected = false;
        return item;
      });
      this.$nextTick(()=>{
        myChart.setOption(option,true);
      })
      //重新获取舆情走势、词云分析、情感分布、媒体预警排行量、群组监测和活跃用户数据并刷新图表及表格
      this.refreshChartsData();
    },
    //重新获取舆情走势、词云分析、情感分布、媒体预警排行量、群组监测和活跃用户数据
    refreshChartsData() {
      //更新舆情走势数据
      this.getTrendInfo();
      //更新词云分析数据
      this.getWordCloudInfo();
      //更新情感分布数据
      this.getEmotionsDistributionInfo();
      //更新媒体预警排行量数据
      this.getMediaAlertInfo();
      //更新群组监测和活跃用户数据
      this.getGroupSpecInfoAndActiveUser();
    },
    //生成折线图--全部
    generateCharts_line_all() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_total);
      let option = {
        xAxis: {
          type: "category",
          data: this.sentimentTrendData.xData, //x轴数据
          // max:'dataMax',

          axisLabel:{
            showMinLagel:true,
            showMaxLabel: true,
            rotate: 45,
            interval: parseInt(this.sentimentTrendData.xData.length / 10)
          },
          axisTick:{
            alignWithLabel: true
          }
          // splitLine:{
          //   interval: 0
          // }
        },
        yAxis: {
          type: "value"
        },
        title:{
          text:'舆情走势',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        grid: {
          top: "8%",
          left: "8%",
          right: "8%",
          bottom: "10%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            name: "全部",
            data: this.sentimentTrendData.charts_all,
            itemStyle: {
              normal: {
                color: "#4CB6FF",
                lineStyle: {
                  color: "#4CB6FF"
                }
              }
            },
            smooth: true,
            type: "line"
          }
        ]
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_all = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成折线图--来源分类
    generateCharts_line_source() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_source);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.sentimentTrendData.charts_source.data_legend, //所有来源的legend名称
          y: "380px"
        },
        title:{
          text:'舆情走势',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        grid: {
          top: "8%",
          left: "8%",
          right: "8%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.sentimentTrendData.xData, //x轴数据
          // max:'dataMax',
          axisLabel:{
            showMinLagel:true,
            showMaxLabel: true,
            rotate: 45,
            interval: parseInt(this.sentimentTrendData.xData.length / 10)
          },
          axisTick:{
            alignWithLabel: true
          }
        },
        yAxis: {
          type: "value"
        },
        series: this.sentimentTrendData.charts_source.data_y
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_source = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成折线图--情感分类
    generateCharts_line_emotions() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_emotions);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.sentimentTrendData.charts_emotion.data_legend, //所有来源的legend名称
          y: "380px"
        },
        title:{
          text:'舆情走势',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        grid: {
          top: "8%",
          left: "8%",
          right: "8%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.sentimentTrendData.xData, //x轴数据
          // max:'dataMax',
          axisLabel:{
            showMinLagel:true,
            showMaxLabel: true,
            rotate: 45,
            interval: parseInt(this.sentimentTrendData.xData.length / 10)
          },
          axisTick:{
            alignWithLabel: true
          }
        },
        yAxis: {
          type: "value"
        },
        series: this.sentimentTrendData.charts_emotion.data_y
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_emotions = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成词云
    generateCharts_wordCloud() {
      this.isBtnDownloadDisabled_wordCloud = true;
      let myChart = this.echarts.init(this.$refs.charts_wordCloud);
      let option = {
        tooltip: {
          show: true
        },
        grid: {
          x: 10,
          y: 10,
          x2: 10,
          y2: 10
        },
        title:{
          text:'词云分析',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        series: [
          {
            name: "词云分析",
            type: "wordCloud",
            size: ["95%", "95%"],
            rotationRange: [0, 0],
            sizeRange: [40, 80],
            textPadding: 0,
            autoSize: {
              enable: true,
              minSize: 14
            },
            data: this.wordCloudData
          }
        ]
      };

      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_wordCloud = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_wordCloud = false;
      }, 2000);
    },
    //生成空心饼图
    generateCharts_circle() {
      this.isBtnDownloadDisabled_emotions = true;
      let myChart = this.echarts.init(this.$refs.charts_circle);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        grid: {
          left: "7%",
          right: "7%",
          bottom: "7%",
          top: "7%",
          containLabel: true
        },
        title:{
          text:'情感分布',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        series: [
          {
            name: "情感分布",
            type: "pie",
            radius: ["50%", "65%"],
            label: {
              normal: {
                formatter: "{b}\n({d}%) ",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: "15" //文字的字体大小
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "20",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: this.emotionsDistrubutionData
          }
        ]
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_emotions = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_emotions = false;
      }, 2000);
    },
    //根据词云的情感生成颜色
    generateColor(prop) {
      let obj = {
        normal: {
          color: ""
        }
      };
      switch (prop) {
        //正面
        case 2:
          obj.normal.color = "#44C58D";
          break;
        //中性
        case 0:
          obj.normal.color = "#FFA810";
          break;
        //负面
        case 1:
          obj.normal.color = "#FA5D5D";
          break;
        default:
          break;
      }
      return obj;
    },
    //根据<任务分布>表格数据，改变表格样式
    changeTaskTableStyle() {
      let tableBodyHeight = window.getComputedStyle(
        document.getElementsByClassName("table-body")[0]
      ).height;
      if (parseInt(tableBodyHeight) <= 320) {
        $(".table-task-content").css({
          "overflow-y": "unset"
        });
      } else {
        $(".table-task-content").css({
          "overflow-y": "auto"
        });
      }
    },
    //切换<舆情走势>的tab按钮
    handleSelectBtnTrend(params) {
      this.btnTrendIsActive.all = this.btnTrendIsActive.source = this.btnTrendIsActive.emotions = false;
      this.btnTrendIsActive[params] = true;
      if (params === "all") {
        this.generateCharts_line_all();
      } else if (params === "source") {
        this.generateCharts_line_source();
      } else if (params === "emotions") {
        this.generateCharts_line_emotions();
      }
    },
    noticeScrollUp() {
      // eslint-disable-next-line no-unused-vars
      this.noticeIntnum = setInterval(_ => {
        if (this.noticeIndex < this.noticeList.length -1) {
          this.noticeIndex += 1;
        } else {
          this.noticeIndex = 0;
        }
      }, 2000);
    },

    noticeStop() {
      clearInterval(this.noticeIntnum);
      console.log("stop");
    },
    noticeUp() {
      this.noticeScrollUp();
      console.log("up");
    }
  }
};
</script>

<style lang="less">
@import "../../../style/common.less";
#page-home {
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #333333 !important;
    letter-spacing: 0;
    letter-spacing: -0.29px;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #333333 !important;
    letter-spacing: 0;
    letter-spacing: -0.29px;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #333333 !important;
    letter-spacing: 0;
    letter-spacing: -0.29px;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #333333 !important;
    letter-spacing: 0;
    letter-spacing: -0.29px;
  }
  .section-title {
    margin-left: 24px;
    text-align: left;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    color: #333333;
    letter-spacing: 0;
    margin-top: 20px;
  }
  .section-notice {
    font-family: PingFangSC-Medium;
    width: 1159px;
    height: 50px;
    background-color: #fffcdd;
    margin: 0 auto;
    text-align: left;
    margin-top: 15px;
    margin-bottom: -8px;
    padding: 5px 0;
    .notice-title{
      line-height: 40px;
      font-size: 16px;
      font-weight: bold;
      padding: 0 28px;
      float: left;
    }
    .notice-list {
      float: left;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      .scroll-content {
        line-height: 40px;
        position: relative;
        transition: top 0.5s;
      }
    }
    .notice-all {
      padding: 0 40px;
      float: right;
      height: 40px;
      line-height: 40px;
    }
  }
  // 时间周期----------------------------------------------------------//
  .section-timePeriod {
    height: 110px;
    width: 1159px;
    margin: 0 auto;
    margin-top: 23px;
    background-color: #fff;
    text-align: left;
    padding: 28px;
    .timePeriod-title {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #333333;
      letter-spacing: 0;
      line-height: 46px;
      vertical-align: top;
    }
    .btnGroup {
      margin-left: 17px;
      width: 733px;
      height: 46px;
      display: inline-block;
      cursor: pointer;
      .btnItem {
        float: left;
        height: 46px;
        box-sizing: border-box;
        width: 116px;
        line-height: 46px;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        border-top: 1px solid #d8d9dc;
        border-bottom: 1px solid #d8d9dc;
        border-left: 1px solid #d8d9dc;
        transition: all 0.2s ease-in-out;
      }
      .btnItem:first-child {
        border-radius: 4px 0 0 4px;
      }
      .btnItem-datePicker {
        float: left;
        height: 46px;
        width: 267px;
        line-height: 44px;
        border-left: 1px solid #d8d9dc;
        border-top: 1px solid #d8d9dc;
        border-bottom: 1px solid #d8d9dc;
        border-right: 1px solid #d8d9dc;
        border-radius: 0 4px 4px 0;
      }
      .btn-Item-selected {
        background: #415af6;
        color: #fff;
      }
      .datePicker {
        height: 46px;
        width: 265px !important;
        input {
          border: none;
          box-shadow: none;
          font-size: 18px;
          color: #333333;
        }
      }
    }
  }
  // 统计数据----------------------------------------------------------//
  .section-statistics {
    .list-statistics {
      width: 1160px;
      height: 161px;
      margin: 0 auto;
      margin-top: 17px;
      .listItem {
        float: left;
        height: 100%;
        width: 220px;
        margin-left: 15px;
        box-sizing: border-box;
        padding: 38px 0 45px 28px;
        .listItem-title {
          text-align: left;
          font-family: PingFangSC-Regular;
          font-size: 24px;
          color: #6f7a91;
          letter-spacing: 0;
        }
        .listItem-num {
          margin-top: 0px;
        }
      }
      .listItem:first-child {
        margin-left: 0px;
      }
      .listItem-sum {
        background: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 1) 65%,
          rgba(51, 51, 51, 0.1) 96%
        );
        border-bottom: 4px solid #333;
      }
      .listItem-positive {
        background: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 1) 65%,
          rgba(68, 197, 141, 0.1) 93%
        );
        border-bottom: 4px solid #44c58d;
        .listItem-num {
          color: #44c58d;
        }
      }
      .listItem-middle {
        background: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 1) 65%,
          rgba(255, 168, 16, 0.1) 98%
        );
        border-bottom: 4px solid #ffa810;
        .listItem-num {
          color: #ffa810;
        }
      }
      .listItem-negative {
        background: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 1) 65%,
          rgba(250, 93, 93, 0.1) 100%
        );
        border-bottom: 4px solid #fa5d5d;
        .listItem-num {
          color: #fa5d5d;
        }
      }
      .listItem-warn {
        background: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 1) 65%,
          rgba(144, 19, 254, 0.1) 100%
        );
        border-bottom: 4px solid #9013fe;
        .listItem-num {
          color: #9013fe;
        }
      }
      .listItem-num {
        text-align: left;
        font-family: PingFangSC-Regular;
        font-size: 46px;
        color: #00133c;
        letter-spacing: 0;
        margin-top: -8px;
      }
    }
  }
  // 任务分布----------------------------------------------------------//
  .section-taskDistribution {
    height: 453px;
    width: 1159px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 17px;
    background: #fff;
    overflow: hidden;
    .taskDistribution-content {
      overflow: hidden;
      .ls {
        float: left;
        margin-left: 24px;
        .charts_pie {
          height: 318px;
          width: 374px;
        }
        .tip {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #333333;
          text-align: center;
          line-height: 60px;
        }
      }
      .rs {
        float: right;
        .table-wrapper {
          .table-task-head {
            margin: 0 auto;
            width: 687px;
            .table-head {
              line-height: 40px;
              background-color: #f8fafe;
              font-family: PingFangSC-Medium;
              font-size: 14px;
              color: #333333;
              letter-spacing: 0;
              font-weight: bold;
              tr {
                th {
                  width: 80px;
                  border-top: 1px solid #efeff4;
                }
                th:first-of-type {
                  border-left: 1px solid #efeff4;
                }
                th:last-of-type {
                  border-right: 1px solid #efeff4;
                  width: 82px;
                }
              }
            }
          }
          .table-task-content {
            overflow-y: scroll;
            overflow-x: hidden;
            max-height: 320px;
            width: 657px;
            .table-body {
              tr {
                border-bottom: 1px solid #efeff4;
                transition: all 0.3s ease-in;
                &:hover {
                  background-color: #f0f8ff;
                }
                td {
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #333333;
                  letter-spacing: 0;
                  line-height: 39px;
                  border-bottom: 1px solid #efeff4;
                  width: 80px;
                }
                td:first-of-type {
                  border-left: 1px solid #efeff4;
                }
                td:last-of-type {
                  border-right: 1px solid #efeff4;
                  width: 82px;
                }
              }
            }
          }
        }
      }
    }
  }
  .wrapper1 {
    overflow: hidden;
    width: 1160px;
    height: 540px;
    margin: 0 auto;
    margin-top: 18px;
    // 舆情走势----------------------------------------------------------//
    .section-trend {
      height: 100%;
      width: 571px;
      float: left;
      background-color: #fff;
      position: relative;
      .icon-download {
        width: 66px;
        height: 22px;
        line-height: 22px;
        border: 1px solid #415af6;
        color: #415af6;
        border-radius: 11px;
        position: absolute;
        text-align: right;
        padding-right: 12px;
        right: 24px;
        top: 30px;
        cursor: pointer;
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 12px;
          transform: translate(0, -50%);
          display: inline-block;
          background: url("https://static.rong360.com/upload/png/95/75/95756aa6fad3be38a4101f5ae0c3dee7.png");
          height: 14px;
          width: 10px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
        &:hover {
          opacity: 0.8;
        }
      }
      .btnGroup {
        margin-top: 26px;
        width: 240px;
        height: 22px;
        margin-left: 24px;
        cursor: pointer;
        user-select: none;
        .btnItem {
          width: 80px;
          color: #415af6;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          height: 22px;
          line-height: 22px;
          border: 1px solid #415af6;
          border-left: none;
          float: left;
          transition: all 0.2s ease-in-out;
          &:hover {
            opacity: 0.8;
          }
        }
        .btnItem:first-child {
          border-left: 1px solid #415af6;
          border-radius: 3px 0 0 3px;
        }
        .btnItem:last-child {
          border-radius: 0 3px 3px 0;
        }
        .isSelected {
          background-color: #415af6;
          color: #fff;
        }
      }
      .charts-wrapper {
        height: 400px;
        width: 524px;
        margin-left: 24px;
        .charts_line_total,
        .charts_line_source,
        .charts_line_emotions {
          height: 400px;
          width: 524px;
        }
      }
    }
    // 词云分析----------------------------------------------------------//
    .section-wordCloud {
      position: relative;
      height: 100%;
      width: 571px;
      background-color: #fff;
      float: right;
      .icon-download {
        width: 66px;
        height: 22px;
        line-height: 22px;
        border: 1px solid #415af6;
        color: #415af6;
        border-radius: 11px;
        position: absolute;
        text-align: right;
        padding-right: 12px;
        right: 24px;
        top: 30px;
        cursor: pointer;
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 12px;
          transform: translate(0, -50%);
          display: inline-block;
          background: url("https://static.rong360.com/upload/png/95/75/95756aa6fad3be38a4101f5ae0c3dee7.png");
          height: 14px;
          width: 10px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
        &:hover {
          opacity: 0.8;
        }
      }
      .charts-wrapper {
        height: 400px;
        width: 524px;
        margin-left: 24px;
        .charts_wordCloud {
          height: 400px;
          width: 524px;
        }
      }
      .wordCloud-footer {
        position: absolute;
        bottom: 0;
        height: 80px;
        width: 100%;
        display: flex;
        justify-content: center;
        .wordCloud-legend {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #666666;
          line-height: 80px;
        }
        .legend-positive {
          &::before {
            content: "";
            display: inline-block;
            height: 10px;
            width: 10px;
            border-radius: 50%;
            background-color: #44c58d;
            margin-right: 6px;
          }
        }
        .legend-middle {
          margin: 0 30px;
          &::before {
            content: "";
            display: inline-block;
            height: 10px;
            width: 10px;
            border-radius: 50%;
            background-color: #ffa810;
            margin-right: 6px;
          }
        }
        .legend-negative {
          &::before {
            content: "";
            display: inline-block;
            height: 10px;
            width: 10px;
            border-radius: 50%;
            background-color: #fa5d5d;
            margin-right: 6px;
          }
        }
      }
    }
  }
  .wrapper2 {
    overflow: hidden;
    width: 1160px;
    margin: 0 auto;
    margin-top: 18px;
    // 情感分布----------------------------------------------------------//
    .section-emotionsDistribution {
      height: 548px;
      width: 571px;
      float: left;
      background-color: #fff;
      position: relative;
      .icon-download {
        width: 66px;
        height: 22px;
        line-height: 22px;
        border: 1px solid #415af6;
        color: #415af6;
        border-radius: 11px;
        position: absolute;
        text-align: right;
        padding-right: 12px;
        right: 24px;
        top: 30px;
        cursor: pointer;
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 12px;
          transform: translate(0, -50%);
          display: inline-block;
          background: url("https://static.rong360.com/upload/png/95/75/95756aa6fad3be38a4101f5ae0c3dee7.png");
          height: 14px;
          width: 10px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
        &:hover {
          opacity: 0.8;
        }
      }
      .charts-wrapper {
        height: 337px;
        width: 524px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .charts_circle {
          height: 337px;
          width: 524px;
        }
      }
    }
    // 媒体预警排行----------------------------------------------------------//
    .section-mediaAlert {
      position: relative;
      height: 548px;
      width: 571px;
      background-color: #fff;
      float: right;
    }
  }

    .section-mediaAlert {
      position: relative;
      height: 548px;
      width: 571px;
      background-color: #fff;
      float: right;

      .table-highlightEvent {
        .table-head {
          tr {
            th {
              width: 174px;
            }
          }
        }
        .table-body {
          tr {
            td {
              width: 174px;
            }
          }
        }
      }
    }

  .wrapper3 {
    overflow: hidden;
    width: 1160px;
    margin: 0 auto;
    margin-top: 18px;

    // 群组监测----------------------------------------------------------//
    .section-groupSpec {
      height: 548px;
      width: 571px;
      float: left;
      background-color: #fff;
      position: relative;
      .table;
      margin-top: 0;
    }
    // 群组活跃用户监测----------------------------------------------------------//
    .section-activeUserSpec {
      height: 548px;
      width: 571px;
      float: right;
      background-color: #fff;
      position: relative;
      .table;
      margin-top: 0;
    }
  }
}
</style>
